import { ChoiceModel } from "./ChoiceModel";
import { LogicModel } from "./LogicModel";
import { TranslatedText } from "./TranslatedText";

export class VariableToChoiceModel implements ChoiceModel {
    elementId: string;
    index: number;
    value: string;
    parentValue: string;
    openEndDisplayLogic: LogicModel;
    openEndActive?: boolean;
    position?: number;
    name: string;
    settings: { [key: string]: any };
    skipLogic?: LogicModel;
    displayLogic?: LogicModel;
    translatedTexts?: { [key: string]: TranslatedText };

    constructor(
        elementId: string,
        index: number,
        value: string,
        name: string,
        openEndActive?: boolean,
        translatedTexts?: { [key: string]: TranslatedText },
    ) {
        this.elementId = elementId;
        this.index = index;
        this.value = value;
        this.name = name;
        this.openEndActive = openEndActive;
        this.translatedTexts = translatedTexts;
    }
}
